import React,{Component} from 'react';
import {withTranslation } from 'react-i18next';
import ApprovalComponent from '../approval-component/ApprovalComponent';
import Loader from "../Common/Loader";
import NoRecords from "../Common/NoRecords";
import {setApprovalId} from '../../actions/ApprovalDetailActions';
import {getApprovalDetails} from '../../actions/ApprovalListActions';
import {connect} from "react-redux";
import _ from "lodash";

export class ApprovalDetails extends Component{
    constructor(props){
        super(props);
        this.state ={
            context:'APPROVAL_DETAILS'
        };
    }
    componentDidMount(){
        if(this.props.match.params.approvalId){
            this.props.setDetailsApprovalId(this.props.match.params.approvalId);
            this.customerGuid = _.has(this.props.userDetails,'userId') ? this.props.userDetails.userId : '';
            this.props.getApprovalDetails(this.props.match.params.approvalId);
        }
    }

    renderDetails(){
        return (
            <div className="TableContainer">
                {(this.props.approvalId !== "" && this.props.approvalList && this.props.userDetails.userId ) ? (
                    <ApprovalComponent history={this.props.history} approvalList={this.props.approvalList} approvalId={this.props.approvalId} context={this.state.context} customerGuid={this.props.userDetails.userId}/>
                ) : ('')}
            </div>
        )
    }

    renderLoading(){
        return (<Loader loaderSize="M"/>);
    }

    renderNoRecords(){
        return (<NoRecords message="noRecordsFound" approvalId={this.props.match.params.approvalId}/>);
    }

    render(){
        var isListValid = (!_.isUndefined(this.props.approvalList) && this.props.approvalList.length);

        return  this.props.apiStatus ? this.renderLoading() : (isListValid) ? (this.renderDetails()) : this.renderNoRecords();
    }
}

const mapStateToProps = (state)=>{
    return{
        approvalId:state.ApprovalDetailReducer.approvalId,
        approvalList : state.ApprovalListReducer.approvalList,
        apiStatus:state.ApprovalListReducer.apiStatus,
        userDetails:state.AuthReducer.userInfo
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setDetailsApprovalId:(approvalId)=>{dispatch(setApprovalId(approvalId))},
        getApprovalDetails : (approvalId)=>{dispatch(getApprovalDetails(approvalId))}

    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ApprovalDetails));
